import camelcaseKeys from 'camelcase-keys';

export function companyFromApi(apiCompany) {
  return {
    ...camelcaseKeys(apiCompany),
    address: apiCompany.address ? apiCompany.address.three_line : null,
    addressOneLine: apiCompany.address ? apiCompany.address.one_line : null,
    addressTruncated: apiCompany.address ? apiCompany.address.truncated : null,
    lastUpdated: apiCompany.formatted_updated_at,
    modelType: 'Contacts::Company',
    phoneNumbers: apiCompany.phone_numbers.map(phone => phoneFromApi(phone)),
    referral: apiCompany.referral_source,
    showPath: apiCompany.paths.show,
    tagsPath: apiCompany.paths.tags,
    useTruncatedAddress: apiCompany.address ? apiCompany.address.use_truncated : false,
    updatePath: apiCompany.paths.update,
    mergePath: apiCompany.paths.merge
  };
}

export function metaFromApi(apiMeta) {
  const getPaginatedData = data => ({
    currentPage: data.current_page,
    pageSize: data.page_size,
    totalCount: data.total_count,
    totalPages: data.total_pages,
    allIds: data.all_ids,
    databaseCount: data.database_count,
    totalUngroupedCount: data.total_ungrouped_count
  });

  return {
    companies: getPaginatedData(apiMeta.companies),
    people: getPaginatedData(apiMeta.people)
  };
}

export function personFromApi(apiPerson) {
  return {
    ...camelcaseKeys(apiPerson),
    address: apiPerson.address_formatted,
    company: {
      address: apiPerson.company_address,
      name: apiPerson.company_name,
      showPath: apiPerson.company_url
    },
    emailAddresses: apiPerson.email_addresses.map(email => camelcaseKeys(email)),
    mergePath: apiPerson.paths.merge,
    mobilePhone: apiPerson.mobile_phone_formatted,
    mobilePhoneNormalized: apiPerson.mobile_phone,
    modelType: apiPerson.contact_type,
    name: apiPerson.name,
    officePhone: apiPerson.office_phone_formatted,
    officePhoneNormalized: apiPerson.office_phone,
    phone: apiPerson.phone_formatted,
    phoneNormalized: apiPerson.phone,
    phoneNumbers: apiPerson.phone_numbers.map(phone => phoneFromApi(phone)),
    showPath: apiPerson.paths.show,
    tagsPath: apiPerson.paths.tags,
    updatePath: apiPerson.paths.update
  };
}

function phoneFromApi(phoneNumber) {
  return {
    extension: phoneNumber.extension,
    fax: phoneNumber.fax,
    label: phoneNumber.label,
    number: phoneNumber.formatted,
    numberNormalized: phoneNumber.number,
    primary: phoneNumber.primary
  };
}
